// منبع :
// https://www.digitalocean.com/community/tutorials/vuejs-vue-chart-js
// https://www.chartjs.org/docs/latest/
export const planetChartData = {
    type: "line",
    data: {
        labels: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"],
        datasets: [{
                label: "درآمد",
                data: [20, 18, 15, 25, 30, 35, 25, 20, 30, 35, 40, 45],
                backgroundColor: 'rgba(255, 205, 86, 0.2)',
                borderColor: 'rgb(255, 205, 86)',
                borderWidth: 2
            },
            {
                label: "هزینه",
                data: [30, 35, 40, 45, 50, 25, 40, 30, 35, 40, 45, 50],
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgb(75, 192, 192)',
                borderWidth: 2
            },
        ]
    },
    options: {
        responsive: false,
        maintainAspectRatio: true,
        showScale: false,

        lineTension: 1,
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    padding: 25,
                    fontFamily: "VazirFD",
                }
            }],
            xAxes: [{
                ticks: {
                    beginAtZero: true,
                    padding: 15,
                    fontFamily: "VazirFD",
                }
            }],

        },
        legend: {
            labels: {
                fontFamily: 'VazirFD'
            }
        },
        tooltip: {
            // fontFamily: 'VazirFD',

            // titleFont: {
            //     fontFamily: 'VazirFD',
            //     size: 100
            // },
            // bodyFont: {
            //     fontFamily: 'VazirFD',
            //     size: 50
            // },
            // footerFont: {
            //     fontFamily: 'VazirFD',
            //     size: 20 // there is no footer by default
            // },

            // titleFontSize: 16,
            // titleFontColor: '#0066ff',
            // titleFontFamily: 'VazirFD'

            // font: { Family: 'VazirFD' }
        }
    }
};

export default planetChartData;


// WEBPACK FOOTER //
// ./src/pages/AdminPanel/Components/Dashboard/ChartComponents/left-chart-data.js